import { jsxs as n, jsx as r } from "@emotion/react/jsx-runtime";
import { useState as p, Fragment as f } from "react";
import { FontAwesomeIconsPartooUsed as c, Stack as m, Text as e, Notification as h, Icon as d, IconPrefix as I, Expandable as C, capitalize as y } from "@partoohub/ui";
import { InformationCardContainer as u, InformationCardTrigger as x, IconCaretContainer as T, StyledSeparator as b, InformationCardTriggered as v, InformationCardIconTriggered as w, InformationCardDescriptionTriggered as j } from "./InformationCard.styled.js";
import { HELP_TYPE as E } from "../../NotificationPanel.types.js";
const U = ({
  items: a = []
}) => {
  const [t, l] = p(!1), s = () => l((o) => !o), g = t ? c.faChevronUp : c.faChevronDown, i = a?.length ?? 0;
  return a.length === 0 ? null : /* @__PURE__ */ n(u, { children: [
    /* @__PURE__ */ n(x, { onClick: s, direction: "row", justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ n(m, { gap: "4px", direction: "row", children: [
        /* @__PURE__ */ r(e, { variant: "bodyMBold", as: "span", children: a[0]?.category }),
        i > 0 && /* @__PURE__ */ r(h, { dataTrackId: "", variant: "primary", size: "small", text: `${i}` })
      ] }),
      /* @__PURE__ */ r(T, { children: /* @__PURE__ */ r(d, { icon: [g, I.REGULAR], color: "secondary" }) })
    ] }),
    /* @__PURE__ */ r(C, { opened: t, children: a.map((o) => /* @__PURE__ */ n(f, { children: [
      /* @__PURE__ */ r(b, {}),
      /* @__PURE__ */ n(v, { direction: "row", alignItems: "top", children: [
        /* @__PURE__ */ r(w, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ r(d, { icon: o.icon, color: "slate" }) }),
        /* @__PURE__ */ n(j, { gap: "4px", children: [
          /* @__PURE__ */ r(e, { variant: "bodyMRegular", as: "span", children: o.message }),
          o?.category !== E && /* @__PURE__ */ n(e, { variant: "bodyMRegular", as: "span", color: "secondary", children: [
            o.date,
            " - ",
            y(o.product)
          ] })
        ] })
      ] })
    ] }, o.id)) })
  ] });
};
export {
  U as InformationCard
};
